import React from 'react';

import { type DialogContextType } from './types';

const dialogsContextState: DialogContextType = {
	openDialog: () => null,
	closeDialog: () => null,
};

export const DialogsContext: React.Context<DialogContextType> =
	React.createContext<DialogContextType>(dialogsContextState);
